import * as React from 'react';

import { MouseEventsEnum } from '../constants/shell';

export interface IRefObject {
  current: any;
}

export default (ref: IRefObject, callback: (_?: any) => void) => {
  const handleClickOutside = React.useCallback(
    (event: Event) => {
      if (ref.current && !ref.current.contains(event.target) && callback) {
        callback();
      }
    },
    [ref, callback],
  );

  React.useEffect(() => {
    document.addEventListener(MouseEventsEnum.MouseDown, handleClickOutside);
    return () => {
      document.removeEventListener(MouseEventsEnum.MouseDown, handleClickOutside);
    };
  }, [handleClickOutside]);
};
